import React from "react"
import Ripple from './Ripple'

const CustomButton = ({ 
    func, tabbing = "normal", className,
    children, rippleColor, type, loading
}) => {
    const tabIndex = tabbing === 'normal' 
    ? "0" : tabbing === "modal" 
    ? "-1" : tabbing === "responsive" 
    && window.innerWidth > 768 ? "0" : "-1"
    
    const loadingClass = loading ? " csButton__loading" : ""

    return (
        <button
            onClick={func}
            className={"csButton " + className + loadingClass}
            role="button"
            type={type ?? ""}
            tabIndex={tabIndex}
            onKeyUp={(e) => {
                if (e.key === "Enter" && !loading) func()
            }}
        >
            {rippleColor && <Ripple bubbleColor={rippleColor}/>}
            {children}
            {loading && <div class="loader" />}
        </button>
    )
}

export default CustomButton
